import React from "react";
import WidgetText from "../Widgets/WidgetText";
import WidgetList from "../Widgets/WidgetList";
import WidgetLink from "../Widgets/WidgetLink";
import ContactMapSection from "../ContactSection/ContactMapSection";

const UpperFooter: React.FC = () => {
    type Item = [string, string | null];

    interface Link {
        url: string,
        linkName: string
    }

    const leftLinks: Link[] = [
        {
            linkName: "O mne",
            url: "/o-mne"
        },
        {
            linkName: "Program",
            url: "/program"
        },
        {
            url: "/aktuality",
            linkName: "Aktuality"
        },
        {
            linkName: "Kontakt",
            url: "/kontakt"
        },
    ]

    return (
        <div className="upper-footer">
            <div className="container">
                <div className="row">
                <div className="col col-lg-3 col-md-3 col-sm-6">
                    <div className="widget about-widget">
                        <div className="widget-title">
                            <h3>Kontakt</h3>
                        </div>
                            <p>Ľubomír Luhový<br></br>Kandidát na primátora mesta Púchov</p>
                            <p>Podporte ma cez transparentny ucet:<br></br>020 01 00000000000000</p>
                            <p>QR cod<br></br>s020 01 00000000000000</p>
                            <p style={{textDecoration: "underline"}}><a href="tel:+421xxxxxxxx">+421 XXX xx xx xx</a></p>
                            <p style={{textDecoration: "underline"}}><a href="mailto:lubomir@luhovy.sk">lubomir@luhovy.sk</a></p>
                    </div>
                </div>
                    <WidgetLink title="Rýchle odkazy" linksLeft={leftLinks} linksRight={[]}/>
                    
                </div>
            </div>
        </div>
    );
}

export default UpperFooter;